import { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { categories, mainSiteUrl } from "@/mocks/kakobuy";

const articleNavLinks = [
  { label: "Co to jest Spreadsheet?", path: "/artykul/kakobuy-spreadsheet-co-to-jest" },
  { label: "Jak korzystać?", path: "/artykul/jak-korzystac-z-kakobuy-spreadsheet" },
  { label: "Najlepszy 2026", path: "/artykul/najlepszy-kakobuy-spreadsheet-2026" },
  { label: "Wersja Polska", path: "/artykul/kakobuy-spreadsheet-polska" },
  { label: "Bezpieczeństwo", path: "/artykul/czy-kakobuy-jest-bezpieczny" },
  { label: "Kakobuy vs AllChinaBuy", path: "/artykul/kakobuy-vs-allchinabuy" },
  { label: "Kakobuy vs OrientDig", path: "/artykul/kakobuy-vs-orientdig" },
  { label: "Kakobuy vs Superbuy", path: "/artykul/kakobuy-vs-superbuy" },
  { label: "Najlepszy Agent", path: "/artykul/najlepszy-agent-zakupowy-polska" },
];

export default function Navbar() {
  const [categoriesOpen, setCategoriesOpen] = useState(false);
  const [articlesOpen, setArticlesOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileCategoriesOpen, setMobileCategoriesOpen] = useState(false);
  const [mobileArticlesOpen, setMobileArticlesOpen] = useState(false);
  const categoriesRef = useRef<HTMLDivElement>(null);
  const articlesRef = useRef<HTMLDivElement>(null);
  const catsTimeout = useRef<ReturnType<typeof setTimeout> | null>(null);
  const artsTimeout = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (categoriesRef.current && !categoriesRef.current.contains(e.target as Node)) {
        setCategoriesOpen(false);
      }
      if (articlesRef.current && !articlesRef.current.contains(e.target as Node)) {
        setArticlesOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleCatsEnter = () => {
    if (catsTimeout.current) { clearTimeout(catsTimeout.current); catsTimeout.current = null; }
    setCategoriesOpen(true);
  };
  const handleCatsLeave = () => {
    catsTimeout.current = setTimeout(() => setCategoriesOpen(false), 200);
  };
  const handleArtsEnter = () => {
    if (artsTimeout.current) { clearTimeout(artsTimeout.current); artsTimeout.current = null; }
    setArticlesOpen(true);
  };
  const handleArtsLeave = () => {
    artsTimeout.current = setTimeout(() => setArticlesOpen(false), 200);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background-50 shadow-sm">
      <nav className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16 md:h-[72px]">
          <Link to="/" className="flex items-center gap-2 cursor-pointer flex-shrink-0">
            <span className="text-xl md:text-2xl font-heading font-bold text-foreground-900 tracking-tight">
              kakobuy<span className="text-primary-500">.one</span>
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-6">
            <Link to="/" className="text-sm font-semibold text-foreground-800 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
              Strona główna
            </Link>

            <Link to="/#artykuly" className="text-sm font-semibold text-foreground-800 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
              Przewodnik zakupowy
            </Link>

            <div ref={categoriesRef} className="relative" onMouseEnter={handleCatsEnter} onMouseLeave={handleCatsLeave}>
              <button className="flex items-center gap-1 text-sm font-semibold text-foreground-800 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                Kategorie
                <span className={`w-3.5 h-3.5 flex items-center justify-center transition-transform duration-200 ${categoriesOpen ? "rotate-180" : ""}`}>
                  <i className="ri-arrow-down-s-line text-xs"></i>
                </span>
              </button>
              {categoriesOpen && (
                <div className="absolute top-full left-0 mt-2 bg-background-50 rounded-xl border border-background-200/70 shadow-lg py-2 min-w-[220px] max-h-[420px] overflow-y-auto">
                  {categories.map((cat) => (
                    <a
                      key={cat.nameEn}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="flex items-center gap-2 px-5 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      <span className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                        <i className="ri-arrow-right-up-line text-[10px] text-foreground-400"></i>
                      </span>
                      {cat.name}
                    </a>
                  ))}
                </div>
              )}
            </div>

            <div ref={articlesRef} className="relative" onMouseEnter={handleArtsEnter} onMouseLeave={handleArtsLeave}>
              <button className="flex items-center gap-1 text-sm font-semibold text-foreground-800 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                Artykuły SEO
                <span className={`w-3.5 h-3.5 flex items-center justify-center transition-transform duration-200 ${articlesOpen ? "rotate-180" : ""}`}>
                  <i className="ri-arrow-down-s-line text-xs"></i>
                </span>
              </button>
              {articlesOpen && (
                <div className="absolute top-full right-0 mt-2 bg-background-50 rounded-xl border border-background-200/70 shadow-lg py-2 min-w-[260px] max-h-[420px] overflow-y-auto">
                  {articleNavLinks.map((link) => (
                    <Link
                      key={link.path}
                      to={link.path}
                      className="flex items-center gap-2 px-5 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      <span className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                        <i className="ri-article-line text-[10px] text-foreground-400"></i>
                      </span>
                      {link.label}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="px-4 py-2 text-sm font-semibold text-foreground-700 hover:text-primary-600 border border-background-300 hover:border-primary-300 rounded-full transition-colors whitespace-nowrap cursor-pointer"
            >
              kakobuy spreadsheet
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="px-5 py-2 text-sm font-semibold bg-primary-500 text-white hover:bg-primary-600 rounded-full transition-colors whitespace-nowrap cursor-pointer"
            >
              buy it now
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-9 h-9 flex items-center justify-center cursor-pointer text-foreground-800"
            aria-label="Menu"
          >
            <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-4 max-h-[70vh] overflow-y-auto">
          <div className="flex flex-col gap-1">
            <Link
              to="/"
              onClick={() => setMobileOpen(false)}
              className="flex items-center gap-2 px-3 py-3 text-sm font-semibold text-foreground-800 rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-home-4-line text-foreground-500"></i>
              </span>
              Strona główna
            </Link>

            <Link
              to="/#artykuly"
              onClick={() => setMobileOpen(false)}
              className="flex items-center gap-2 px-3 py-3 text-sm font-semibold text-foreground-800 rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-book-open-line text-foreground-500"></i>
              </span>
              Przewodnik zakupowy
            </Link>

            <button
              onClick={() => setMobileCategoriesOpen(!mobileCategoriesOpen)}
              className="flex items-center justify-between w-full px-3 py-3 text-sm font-semibold text-foreground-800 rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
            >
              <span className="flex items-center gap-2">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-grid-line text-foreground-500"></i>
                </span>
                Kategorie
              </span>
              <span className={`w-5 h-5 flex items-center justify-center transition-transform duration-200 ${mobileCategoriesOpen ? "rotate-180" : ""}`}>
                <i className="ri-arrow-down-s-line text-foreground-500"></i>
              </span>
            </button>
            {mobileCategoriesOpen && (
              <div className="grid grid-cols-2 gap-1 pl-8 pr-2 pb-2">
                {categories.map((cat) => (
                  <a
                    key={cat.nameEn}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="flex items-center gap-1.5 px-2 py-2 text-xs text-foreground-600 rounded-md hover:bg-background-100 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    <span className="w-1.5 h-1.5 rounded-full bg-primary-400 flex-shrink-0"></span>
                    <span className="truncate">{cat.name}</span>
                  </a>
                ))}
              </div>
            )}

            <button
              onClick={() => setMobileArticlesOpen(!mobileArticlesOpen)}
              className="flex items-center justify-between w-full px-3 py-3 text-sm font-semibold text-foreground-800 rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
            >
              <span className="flex items-center gap-2">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-article-line text-foreground-500"></i>
                </span>
                Artykuły SEO
              </span>
              <span className={`w-5 h-5 flex items-center justify-center transition-transform duration-200 ${mobileArticlesOpen ? "rotate-180" : ""}`}>
                <i className="ri-arrow-down-s-line text-foreground-500"></i>
              </span>
            </button>
            {mobileArticlesOpen && (
              <div className="flex flex-col gap-0.5 pl-8 pr-2 pb-2">
                {articleNavLinks.map((link) => (
                  <Link
                    key={link.path}
                    to={link.path}
                    onClick={() => setMobileOpen(false)}
                    className="flex items-center gap-1.5 px-2 py-2 text-xs text-foreground-600 rounded-md hover:bg-background-100 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    <span className="w-1.5 h-1.5 rounded-full bg-secondary-400 flex-shrink-0"></span>
                    <span className="truncate">{link.label}</span>
                  </Link>
                ))}
              </div>
            )}

            <div className="flex flex-col gap-2 pt-3 mt-2 border-t border-background-200/70">
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="w-full text-center px-4 py-3 text-sm font-semibold border border-background-300 rounded-full hover:border-primary-300 transition-colors whitespace-nowrap cursor-pointer"
              >
                kakobuy spreadsheet
              </a>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="w-full text-center px-5 py-3 text-sm font-semibold bg-primary-500 text-white rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                buy it now
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}